import React from 'react';
import headerActions from '../../../../actions/header';
import translate from '../../../../utils/translate';
import Language from '../../language';

export default class TopLinksLanguage extends React.Component {
  static propTypes = {
    isActive: React.PropTypes.bool,
    language: React.PropTypes.object
  };

  state = {
    tabWidth: false
  };

  togglePanel = () => {
    var currentWidth = this.refs['loginBtn'].getBoundingClientRect().width;

    this.setState({
      tabWidth: this.props.isActive ? 'auto' : currentWidth
    });

    headerActions.toggleTopPanel('language');
  };

  renderButtonText = () => {
    return (
      <span>
        {translate('languageModule', 'LANGUAGE')}
        <span className="toplinks__button--language__current">
          {this.props.language.currentLanguage.shortDisplayName}
        </span>
      </span>
    );
  };

  render() {
    return (
      <Language {...this.props.language} />
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/toplinks/btnlanguage/index.js